/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeJobsTerminateJob } from "../../funcs/computeJobsTerminateJob.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.TerminateJobRequest$inboundSchema,
};

export const tool$computeJobsTerminateJob: ToolDefinition<typeof args> = {
  name: "compute-jobs-terminate-job",
  description: `Terminate a job`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await computeJobsTerminateJob(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
